import React from 'react';
import useAuth from '../hooks/useAuth.ts';

interface RoleBasedAccessProps {
  allowedRoles: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const RoleBasedAccess: React.FC<RoleBasedAccessProps> = ({ 
  allowedRoles, 
  children, 
  fallback = null 
}) => {
  const { auth } = useAuth();
  
  // Check if user has one of the allowed roles
  const hasAccess = auth.user && allowedRoles.includes(auth.user.role);
  
  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default RoleBasedAccess;
